import { useEffect, useState } from "react";
import { createBrowserRouter, RouterProvider, useNavigate } from "react-router-dom";

// MANTINE IMPORTS
import {
  createTheme as createMantineTheme,
  Loader,
  MantineProvider,
} from "@mantine/core";
import { Notifications } from "@mantine/notifications";
import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import "@mantine/dropzone/styles.css";
import "@mantine/notifications/styles.css";
import "@mantine/carousel/styles.css";

import "./styles/index.scss";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Overview from "./pages/Inventory";
import SalesRequests from "./pages/SalesRequests";
import Inventory from "./pages/Inventory";
import { usePerformRequest } from "./lib/usePerformRequest";
import { NonPaginatedResponse } from "./lib/Responses";
import { AdminProfileProps } from "./lib/Types";
import { Endpoints } from "./lib/Endpoints";
import MegaLoader from "./components/MegaLoader";
import Team from "./pages/Team";
import Onboard from "./pages/Onboard";
import SingleSaleRequest from "./pages/SingleSaleRequest";
import Profile from "./pages/Profile";
import ResetPassword from "./pages/ResetPassword";
import UpdatePassword from "./pages/UpdatePassword";
import Messages from "./pages/Messages";
import SingleVehicle from "./pages/SingleVehicle";

const mantineTheme = createMantineTheme({
  components: {
    Loader: Loader.extend({
      defaultProps: {
        type: "bars",
      },
    }),
  },
});

const RedirectWhereNecessary = () => {
  const navigate = useNavigate();
  const { isLoading, data, status } = usePerformRequest<
    NonPaginatedResponse<AdminProfileProps>
  >({
    method: "GET",
    route: Endpoints.GetAdminProfile(),
  });
  useEffect(() => {
    if (data) {
      navigate(data.data && data.data.id ? "/dashboard" : "/login");
    }
    if (status && status === 401) {
      navigate("/login");
    }
  }, [isLoading]);

  return (
    <>
      <br />
      <br />
      <MegaLoader />
    </>
  );
};
const router = createBrowserRouter([
  {
    path: "/",
    element: <RedirectWhereNecessary />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/reset",
    element: <ResetPassword />,
  },
  {
    path: "/reset-password/:resetID",
    element: <UpdatePassword />,
  },
  {
    path: "/onboard-member/:adminID",
    element: <Onboard />,
  },
  {
    path: "/dashboard",
    element: <Dashboard />,
    children: [
      { path: "/dashboard", element: <Overview /> },
      { path: "/dashboard/inventory", element: <Inventory /> },
      { path: "/dashboard/inventory/:vehicleID", element: <SingleVehicle /> },
      { path: "/dashboard/requests", element: <SalesRequests /> },
      { path: "/dashboard/request/:requestID", element: <SingleSaleRequest /> },
      { path: "/dashboard/team", element: <Team /> },
      { path: "/dashboard/profile", element: <Profile /> },
      { path: "/dashboard/messages", element: <Messages /> },
    ],
  },
]);
export default function App() {
  return (
    <MantineProvider theme={mantineTheme}>
      <Notifications position="bottom-right" />
      <RouterProvider router={router} />
    </MantineProvider>
  );
}
